import * as React from "react";
import PositionLayout from "../positionLayout/positionLayout";
import { AEqPosition, ACommPosition } from "../../../service/position/positionApiService";
import "../../../../assets/scss/components/toc/position/generic/obPositions.scss";
import Loader from "../../../generic/loader";
import TocNoData from "../../generic/tocNoData/tocNoData";

export interface IPositionContainerProps {}

const PositionContainer: React.FC<IPositionContainerProps> = () => {
	const eqGetpositionRes = (res: any) => {
		if (res.data) {
			setPosData({ data: res.data });
		} else if (res.error) {
			console.log(res.error);

			setPosData({ data: res.error });
		}
	};
	const commdityGetpositionRes = (res: any) => {
		if (res.data) {
			setPosData({ data: res.data });
		} else if (res.error) {
			setPosData({ data: res.error });
		}
	};
	function reducer(_prevState: any, newState: any) {
		return newState;
	}
	function init() {
		ACommPosition(commdityGetpositionRes);
		AEqPosition(eqGetpositionRes);
		return null;
	}
	const [posData, setPosData] = React.useReducer(reducer, null, init);

	return (
		<div className="pos_main_wrap">
			{posData !== null ? (
				posData.data.errMsg ? (
					<TocNoData data={[]} callBackMeth={() => {}} errMsg={<>{posData.data.errMsg}</>} showClrBtn={false} />
				) : (
					<PositionLayout data={posData.data} />
				)
			) : (
				<div className="pos_loader">
					<Loader size={20} color="blue" />
				</div>
			)}
		</div>
	);
};
export default PositionContainer;
